import React from 'react';
import { motion } from 'framer-motion';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
export function KitComparison() {
  const rows = [{
    sit: 'Te piden presupuesto para un evento de 50 personas',
    sin: 'Improvisás el precio y terminás perdiendo plata',
    con: 'Planilla de Cotización Rápida. Presupuesto listo en 2 minutos.'
  }, {
    sit: 'El cliente quiere una temática que no sabés hacer',
    sin: 'Te estresás buscando ideas de apuro',
    con: 'Catálogo de Adaptaciones Estacionales (Navidad, Bodas, San Valentín).'
  }, {
    sit: 'Tenés que calcular insumos para grandes cantidades',
    sin: 'Comprás de más o te quedás corta el día anterior',
    con: 'Calculadora de Escala. Te dice los gramos exactos de base por molde.'
  }, {
    sit: 'Querés presentar el producto a salones o marcas',
    sin: 'Mandás fotos sueltas por WhatsApp sin formalidad',
    con: 'Dossier de Presentación Comercial editable. Imagen 100% corporativa.'
  }];
  return <section className="py-12 px-6 bg-brand-ivory" data-id="element-155">
      <div className="max-w-5xl mx-auto" data-id="element-156">
        <div className="text-center mb-8" data-id="element-157">
          <h2 className="text-3xl font-serif font-bold text-brand-choco-deep" data-id="element-158">
            🕊️ ¿QUÉ AGREGA EL KIT ADAPTACIONES "EMBAJADORA DE EVENTOS"?
          </h2>
        </div>

        {/* Desktop Table */}
        <div className="hidden md:block overflow-hidden rounded-2xl border border-brand-choco/10 shadow-sm bg-white" data-id="element-159">
          <table className="w-full text-left border-collapse" data-id="element-160">
            <thead data-id="element-161">
              <tr className="bg-brand-cream text-brand-choco-deep" data-id="element-162">
                <th className="p-4 font-bold w-1/3 border-b border-brand-choco/10" data-id="element-163">
                  Situación del negocio
                </th>
                <th className="p-4 font-bold w-1/3 border-b border-brand-choco/10 text-brand-burgundy" data-id="element-164">
                  ❌ Sin Kit de Negocio
                </th>
                <th className="p-4 font-bold w-1/3 border-b border-brand-choco/10 text-green-700" data-id="element-165">
                  ✅ Con Kit "Embajadora"
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-brand-choco/5" data-id="element-166">
              {rows.map((row, i) => <tr key={i} className="hover:bg-brand-cream/30 transition-colors" data-id="element-167">
                  <td className="p-4 text-brand-choco-deep font-medium" data-id="element-168">
                    {row.sit}
                  </td>
                  <td className="p-4 text-brand-choco/80" data-id="element-169">{row.sin}</td>
                  <td className="p-4 text-brand-choco-deep font-semibold bg-green-50/30" data-id="element-170">
                    {row.con}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        {/* Mobile Cards */}
        <div className="md:hidden space-y-6" data-id="element-171">
          {rows.map((row, i) => <div key={i} className="bg-white p-5 rounded-xl border border-brand-choco/10 shadow-sm" data-id="element-172">
              <h4 className="font-bold text-brand-choco-deep mb-4 pb-2 border-b border-brand-choco/5" data-id="element-173">
                {row.sit}
              </h4>
              <div className="space-y-3" data-id="element-174">
                <div className="flex gap-2 items-start" data-id="element-175">
                  <CancelIcon className="text-brand-burgundy mt-0.5 flex-shrink-0" fontSize="small" data-id="element-176" />
                  <p className="text-sm text-brand-choco/80" data-id="element-177">{row.sin}</p>
                </div>
                <div className="flex gap-2 items-start bg-green-50 p-2 rounded-lg" data-id="element-178">
                  <CheckCircleIcon className="text-green-600 mt-0.5 flex-shrink-0" fontSize="small" data-id="element-179" />
                  <p className="text-sm text-brand-choco-deep font-semibold" data-id="element-180">
                    {row.con}
                  </p>
                </div>
              </div>
            </div>)}
        </div>

        <div className="mt-8 bg-white p-8 rounded-2xl border border-brand-gold/30 shadow-sm" data-id="element-181">
          <h3 className="text-xl font-bold text-brand-choco-deep mb-6" data-id="element-182">
            ✅ EL KIT PREVENTA INCLUYE:
          </h3>
          <ul className="space-y-3" data-id="element-183">
            {['Plantilla de Cotización para Eventos y Catering.', 'Catálogo de Diseños Temáticos Estacionales (Bodas, 15 Años, Fiestas Corporativas).', 'Calculadora Automática de Insumos a Gran Escala.', 'Guía de Alianzas Comerciales (Cómo ofrecer tu producto a pastelerías y salones).', 'Contratos listos para señas y reservas de fechas.'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-184">
                <CheckCircleIcon className="text-brand-gold mt-0.5 flex-shrink-0" fontSize="small" data-id="element-185" />
                <span className="text-brand-choco-deep/90" data-id="element-186">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}